import {useEffect, useRef} from 'react';

import {
  ErrorScreen,
  LoadingScreen,
  useAppError,
  useConversation,
  useConversationExceptions,
  useConversationInlineDataEvents,
  useCurrentConversation,
} from '@stripe-internal/conversations-assistant';

import {MobileConversationScreen} from './MobileConversationScreen';

export function MobileAssistantScreen() {
  const loadingRef = useRef<boolean>(false);

  const appError = useAppError();

  const currentConversation = useCurrentConversation();
  const {startConversation, error} = useConversation();

  useConversationExceptions(currentConversation);
  useConversationInlineDataEvents(currentConversation);

  useEffect(() => {
    if (currentConversation) {
      loadingRef.current = false;
      return;
    }

    if (loadingRef.current) {
      return;
    }

    loadingRef.current = true;
    try {
      startConversation().then(() => {
        loadingRef.current = false;
      });
    } catch (e) {
      loadingRef.current = false;
    }
  }, [currentConversation, startConversation]);

  if (appError || error) {
    return <ErrorScreen />;
  }

  if (loadingRef.current || !currentConversation) {
    return <LoadingScreen />;
  }

  return <MobileConversationScreen conversation={currentConversation} />;
}
